import React from 'react';

import {
  Accordion, Stack, Text,
} from '@chakra-ui/react';
import { isEmpty } from 'lodash';

import { Button, Icon } from 'components';

interface AccordionsProps {
    data: any[]
    meta: any
    isFetching: boolean
    onPaginate: () => void
    RenderItem: React.FC<any>
    keyExtractor: (_item: any) => string
    expandedItems?: Set<number>
    toggleExpanded?: (_number: number) => void
}

export default function Accordions({
  data,
  meta,
  isFetching,
  onPaginate,
  RenderItem,
  keyExtractor,
  expandedItems,
  toggleExpanded,

}:AccordionsProps) {
  return (
    <Stack as={Accordion}>
      {data?.map((item: any) => (
        <RenderItem
          key={keyExtractor(item)}
          isExpanded={expandedItems?.has(item.id)}
          toggle={() => toggleExpanded?.(item.id)}
          {...item}
        />
      ))}
      <Button
        alignSelf="flex-end"
        isLoading={isFetching}
        hidden={isEmpty(data) || meta?.currentPage === meta?.lastPage}
        _hover={{ bg: 'gray.200' }}
        size="xs"
        width="fit-content"
        bg="white.default"
        onClick={onPaginate}>
        <Text
          color="gray.500"
          variant="xSmallBold">
          Carregar Mais
        </Text>
        <Icon
          ml={2}
          color="gray.500"
          name="arrow-down"
        />
      </Button>
    </Stack>
  );
}
